/**
 * 词条模块
 */
// import topicDetail from 'page/topic/detail.vue'
// import topicForm from 'page/topic/form.vue'
const topicDetail = () =>
  import(/* webpackChunkName: "topic~topicDetail" */ 'page/topic/detail.vue')
const topicForm = () =>
  import(/* webpackChunkName: "topic~topicForm" */ 'page/topic/form.vue')

const routes = [
  {
    path: '/topic/detail',
    component: topicDetail,
    meta: {
      pageName: '词条详情页'
    }
  },

  {
    path: '/qa/citiao/:id',
    component: topicDetail,
    meta: {
      pageName: '贡献词条'
    }
  },

  {
    path: '/topic/form',
    component: topicForm,
    meta: {
      pageName: '贡献词条'
    }
  }
]

export default routes
